var _rect, _rect2, _rect3, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpendesk = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_581_32635",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 7,
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_581_32635)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#5D21D2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_581_32635",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_581_32635)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_581_32635)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5617 26.3253C30.3621 26.1122 30.3621 25.766 30.5617 25.5515L34.2814 21.5507C34.481 21.3376 34.8041 21.3376 35.0009 21.5507L42.5219 29.6324C42.7744 29.9147 42.9292 30.2976 42.9292 30.7184C42.9292 31.1488 42.7703 31.5357 42.511 31.8208L34.7919 40.1156C34.6968 40.2201 34.5665 40.2785 34.4307 40.2785H26.9804C26.7007 40.2785 26.474 40.0341 26.474 39.7354C26.474 39.5725 26.5364 39.43 26.6369 39.3282L34.2882 31.1013C34.3859 30.9981 34.4375 30.8596 34.4375 30.7184C34.4375 30.5772 34.3859 30.4374 34.2882 30.3342L30.5589 26.3253H30.5617ZM25.43 30.3383C25.6282 30.5514 25.6282 30.8976 25.43 31.1121L21.7103 35.1129C21.5107 35.326 21.1876 35.326 20.9907 35.1129L13.4698 27.0312C13.2173 26.7489 13.0625 26.366 13.0625 25.9452C13.0625 25.5162 13.2227 25.1279 13.4806 24.8428L21.1998 16.5453C21.2948 16.4435 21.4252 16.3851 21.5609 16.3851H29.0099C29.291 16.3851 29.519 16.6295 29.519 16.9309C29.519 17.0911 29.4539 17.2336 29.3521 17.3327L21.7008 25.5596C21.603 25.6655 21.5514 25.804 21.5514 25.9452C21.5514 26.0864 21.603 26.2262 21.7008 26.3307L25.4287 30.3383H25.43Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_581_32635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.8667,
    height: 29.8667,
    fill: "white",
    transform: "translate(13.0625 13.0667)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpendesk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spendesk.02d6f81a484f657ea3fd261778f70b48.svg";